// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","segment":"segment-JeXsn","locationsWrapper":"locationsWrapper-2eTcs","location":"location-3ZDiZ","flight":"flight-3Ci4R"};